<div *ngIf="!isOffline" class="rtc-container-principal">
    <mf-portal-layout portal="" class="portal-layout">
        <div class="mensagem">
            <br-alert-messages onlyFor="xxxyyy"></br-alert-messages>
        </div>
        <div class="rtc-container-responsivo">
            <my-breadcrumb></my-breadcrumb>
            <router-outlet></router-outlet>
            <my-loading></my-loading>
            <my-version></my-version>
        </div>
    </mf-portal-layout>
</div>

<div *ngIf="isOffline">
    <main-layout></main-layout>
</div>